export default process.env.REACT_APP_ENV === "development"
  ? "http://localhost:5000"
  : process.env.REACT_APP_ENV === "staging"
    ? "https://api.staging.admin.kanshitv.co.uk"
    : "https://api.admin.kanshitv.co.uk";